import type { IJobAssociatedTaskSheetConfigurableBody, ITaskSheetSection } from '@/interfaces'
import { TaskSheetSection } from '../task-sheets'
import Base from '../Base'

class JobAssociatedTaskSheetConfigurableBody
  extends Base
  implements IJobAssociatedTaskSheetConfigurableBody
{
  title: string;
  rows: ITaskSheetSection[]

  constructor(taskSheetConfigurableBody?: any) {
    super(taskSheetConfigurableBody)
    this.title = taskSheetConfigurableBody?.title ?? ''
    this.rows = taskSheetConfigurableBody?.rows?.map((row: any) => new TaskSheetSection(row))
  }
}

export default JobAssociatedTaskSheetConfigurableBody
